import React from 'react'
// import '../../../Authentication/LandingPage/style.scss';
import { useSelector } from 'react-redux';

export default function BKTPrivacyPolicy() {

    const webProperties = useSelector(state => state.landingReducer.webProperties)
    return (
        <>
            <nav className="navbar sticky-top navbar-expand-lg navbar-light" style={{backgroundColor: 'white'}}>
                <button style={{background: 'white'}} className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo01"
                    aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarTogglerDemo01">
                    <div className="navbar-brand">
                        <img className="agile-supportlogo" src="images/common/BKTlogo.png" width="110" alt="" />
                    </div>
                </div>
            </nav>
            <div className='container ppc dflex flex-col gap-6 fs-12'>
                <h1>Privacy Policy – BlueKnight Application</h1>
                <h4>Effective Date: April 25, 2025</h4><br/>
                <h4>At BlueKnight, your privacy is important to us. This Privacy Policy outlines how we collect, use, disclose, and protect your personal information when you use the BlueKnight mobile application and related services.</h4><br/>

                <h2>1. Information We Collect</h2>
                <h4>During registration and while using the app, we may collect the following personal data:</h4>
                <ul>
                    <li><h5><strong>Full Name and Photograph</strong></h5></li>
                    <li><h5><strong>Mobile Number</strong></h5></li>
                    <li><h5><strong>Educational Certificates</strong></h5></li>
                    <li><h5><strong>Aadhar Card, Pan Card (or other government-issued ID)</strong></h5></li>
                    <li><h5><strong>Bank Account Details</strong></h5></li>
                    <li><h5><strong>Medical Fitness Certificate, Police Certificate, Education Certificate</strong></h5></li>
                    <li><h5><strong>Device and usage information (for app performance and security)</strong></h5></li>
                </ul>
                <br/>
                <br/>
                <h2>2. How We Use Your Information</h2>
                <h4>Your information is collected for the following purposes:</h4>
                <ul>
                    <li><h5><strong>To verify your identity and credentials.</strong></h5></li>
                    <li><h5><strong>To process your onboarding and employment eligibility.</strong></h5></li>
                    <li><h5><strong>To facilitate salary/payment processing.</strong></h5></li>
                    <li><h5><strong>To match you with suitable guard assignments.</strong></h5></li>
                    <li><h5><strong>To comply with legal and security obligations.</strong></h5></li>
                    <li><h5><strong>To improve the quality and safety of our services.</strong></h5></li>
                </ul>
                <br/>
                <br/>
                <h2>3. Data Protection</h2>
                <h4>We use industry-standard security measures to protect your data from unauthorized access, misuse, or disclosure. Sensitive data such as Aadhar and bank details are encrypted and stored securely.</h4>
                <br/>
                <br/>
                <h2>4. Sharing of Information</h2>
                <h4>We do not sell your personal information. However, we may share it:</h4>
                <ul>
                    <li><h5><strong>With government authorities if legally required</strong></h5></li>
                    <li><h5><strong>With background verification partners</strong></h5></li>
                    <li><h5><strong>With internal HR or administrative teams for recruitment, compliance, and payroll purposes
                    </strong></h5></li>
                </ul>
                <br/>
                <br/>
                <h2>5. Data Retention</h2>
                <h4>We retain your personal data for as long as your account is active or as required by law. You may request deletion of your data after resignation or termination, subject to legal obligations.</h4>
                <br/>
                <br/>
                <h2>6. Your Rights</h2>
                <h4>You have the right to:</h4>
                <ul>
                    <li><h5><strong>Access your personal data</strong></h5></li>
                    <li><h5><strong>Request corrections or updates</strong></h5></li>
                    <li><h5><strong>Withdraw consent or request deletion (where applicable)</strong></h5></li>
                    <li><h5><strong>Lodge a complaint with relevant data protection authorities</strong></h5></li>
                    <li><h5><strong>To exercise these rights, please contact us at:</strong> support@wetasker.com.</h5></li>
                </ul>
                <br/>
                <br/>
                <h2>7. Updates to This Policy</h2>
                <ul>
                    <li><h5>We may update this Privacy Policy from time to time. You will be notified via app updates or in-app alerts when changes occur.</h5></li>
                    <li><h5><strong>Contact Us</strong></h5></li>
                    <li><h5>For any questions, concerns, or feedback related to this policy or your data:</h5></li>

                    <li><h5><strong>BlueKnight Support Team:</strong> support@wetasker.com</h5></li>
                </ul>
            </div>
            <footer id="footer-releasenote" style={{ backgroundColor: webProperties?.PRIMARY_COLOR !== "#47974b" ? webProperties?.PRIMARY_COLOR : '#47974b' }}>
                <div style={{ color: 'white' }}>
                    BlueKnight © Copyright {new Date().getFullYear()}. All Rights Reserved.
                </div>
            </footer>
        </>
    )
}

